import { ExternalLinkButton, type ExternalLinkButtonProps } from "@/components/ui/external-link-button";
import { useAbrirCandidato } from "./painel-do-candidato";

type FreelancerLinkedInButtonProps = Omit<ExternalLinkButtonProps, "kind" | "onOpenInPlatform"> & {
  freelancerId: string | null | undefined;
};

/**
 * LinkedIn de um freelancer: o clique abre a aba LinkedIn do painel do candidato, onde
 * "Abrir no LinkedIn" leva ao site. Cmd ou Ctrl+clique continua indo direto.
 */
export function FreelancerLinkedInButton({ freelancerId, ...props }: FreelancerLinkedInButtonProps) {
  const abrir = useAbrirCandidato();
  const onOpenInPlatform = abrir && freelancerId ? () => abrir(freelancerId, "linkedin") : undefined;
  return <ExternalLinkButton kind="linkedin" onOpenInPlatform={onOpenInPlatform} {...props} />;
}
